import {
  LayoutDashboard,
  Boxes,
  Users,
  DollarSign,
  UserCircle,
  KeyRound,
  Inbox,
  BarChart3,
  BookOpen,
  Receipt,
  Sparkles,
  FileText,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { TimeWindow } from '@/shared/types';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  end?: boolean;
  /** If set, only shown when the user has this role. */
  role?: 'superadmin' | 'client' | 'any';
  /** When set, the sidebar shows a live count badge for this item. */
  badge?: 'modelRequests';
}

export const NAV_ITEMS: NavItem[] = [
  // Super-admin analytics
  { to: '/', label: 'Overview', icon: LayoutDashboard, end: true, role: 'superadmin' },

  // Super-admin management
  { to: '/admin/clients', label: 'Clients', icon: Users, role: 'superadmin' },
  { to: '/admin/requests', label: 'Requests', icon: Inbox, role: 'superadmin', badge: 'modelRequests' },
  { to: '/admin/api-logs', label: 'API Logs', icon: FileText, role: 'superadmin' },
  { to: '/admin/model-catalog', label: 'Model Catalog', icon: DollarSign, role: 'superadmin' },
  { to: '/admin/providers', label: 'Providers', icon: KeyRound, role: 'superadmin' },

  // Client portal
  { to: '/client', label: 'My Account', icon: UserCircle, end: true, role: 'client' },
  { to: '/client/models', label: 'Products', icon: Boxes, role: 'client' },
  { to: '/client/usage', label: 'Usage', icon: BarChart3, role: 'client' },
  { to: '/client/bills', label: 'Bills', icon: Receipt, role: 'client' },
  { to: '/client/docs', label: 'API Docs', icon: BookOpen, role: 'client' },
  { to: '/client/solutions', label: 'More Products', icon: Sparkles, role: 'client' },
];

/** Nav items visible to the given role (items with role 'any'/undefined show to all). */
export function navItemsForRole(role: string | undefined): NavItem[] {
  return NAV_ITEMS.filter((i) => !i.role || i.role === 'any' || i.role === role);
}

export const TIME_WINDOWS: ReadonlyArray<{ value: TimeWindow; label: string }> = [
  { value: '5m', label: '5m' },
  { value: '1h', label: '1h' },
  { value: '24h', label: '24h' },
  { value: '7d', label: '7d' },
];
